// removed by extract-text-webpack-plugin
module.exports = {"Icon":"Icon---1aXVd","DismissIcon":"DismissIcon---1Nkjr"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/shared/MessagePreviews/WelcomeMessage/icons/style.styl
// module id = XydC
// module chunks = 89